/**
 * linkId 的形状,取两套生成规则的【超集】:
 *   - 上游(DeepClick)cloak code:6 位 base62 [A-Za-z0-9]{6}(如 cZ5svC / K0uBqY)。
 *   - beta 本地:nanoid(8),URL-safe 字符集含 _ 和 -。
 * 故字符集用 [A-Za-z0-9_-]、长度放宽到 1..64(与 worker telemetry schema 的 max 64
 * 对齐)。⚠ 不要收紧成纯 base62,否则会误杀 beta 含 _/- 的 nanoid。够拒掉爬虫乱构造
 * 的路径段(`data:,` 含 :,、`.git` 含 .)即可。
 */
export const LINK_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

/**
 * 从落地页路径取首段作为 linkId,并校验形状。异常路径段(`data:,`、`favicon.ico`、
 * 扫描器乱构造的路径等)不符合 linkId 形状时返回 undefined —— 否则会被原样当成
 * linkId 上报,污染埋点的 link 维度(sl_sessions_raw.link_id 出现 `data:,`)。
 */
export function parseLinkIdFromPath(pathname: string): string | undefined {
  const seg = pathname.replace(/^\/+/, '').split('/')[0] ?? '';
  return LINK_ID_PATTERN.test(seg) ? seg : undefined;
}

/**
 * Beta 原生平台的 runtime scope。landing 的 landingRuntimeScope() 在未配置 TENANT
 * 时返回同一个值 —— links 管理接口只在 Beta(local backend)下可用,DC/RB 的链接由各自
 * 业务平台托管,所以这里可以固定成 Beta。
 */
export const BETA_RUNTIME_SCOPE = 'beta:platform';

/**
 * TEMPLATE_KV 里 per-link public config 的键。
 *
 * ⚠ landing 的 functions/_middleware.ts 有一份等价的本地副本(Pages Functions 不能
 *   依赖 workspace 包,同 LINK_ID_PATTERN 的处理),改这里必须同步改那边 —— 两边不一致
 *   会让 links-route 的 write-through/delete 全部打空,模板改动要等 TTL 才生效。
 *
 * 刻意不含 host:失效方只知道 link 配置,无法枚举它可能被访问的全部域名。
 */
export function templateKvKey(scope: string, linkId: string): string {
  return `cfg:${scope}:${linkId}`;
}
